const html = require('choo/html')

const HINTS = [
   "Hold shift while dragging to snap to grid",
   "Press ENTER to duplicate a selected sticker or part",
   "Add the Animate sticker to many small pieces of lava or water to make it look like it flows",
   "You can click on the value of the variable slider to type a number"
]

module.exports = HINTS;